import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  usersListWrapper: {
    '& > div + div': {
      marginTop: 4,
    },
  },
  usersListSearch: {},
  narrowScreen: {},
}));
